import $ from "jquery";
import { trackEvent } from "~/helpers/event";

window.trackEvent = (type) => {
  trackEvent(type);
};
